export function wonString(value: number | string) {
  return `${(+value || 0).toLocaleString()}원`;
}
